import React from "react";
import PropTypes from "prop-types";

import { Form } from "..";

export function FormDateTime({
  id,
  name,
  description,
  value,
  required,
  errorMessage,
  disabled,
  yearRange,
}) {
  return (
    <Form.DateTimePicker
      name={id}
      label={name}
      description={description}
      initialDate={value}
      dataTest="form-datetime"
      placeholderText="e.g. 02/04/2022 6:45pm"
      dateFormat="MM/dd/yyyy h:mmaaa"
      showTimeSelect
      timeIntervals={15}
      required={required}
      errorMessage={errorMessage}
      disabled={disabled}
      yearDropdownItemNumber={yearRange}
    />
  );
}

FormDateTime.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  yearRange: PropTypes.number,
};

FormDateTime.defaultProps = {
  description: "",
  value: null,
  required: true,
  errorMessage: "Please enter the date and time",
  disabled: false,
  yearRange: 120,
};

export default FormDateTime;
